import ManageTable from './manageTable'

export default ManageTable
